// src/etapas/EtapaIdentificacao.js
import React, { useState } from 'react';
import api from '../services/api';

function EtapaIdentificacao({ onNext, setDados, dados }) {
  const [cpfCnpj, setCpfCnpj] = useState('');

  const formatarCpfCnpj = (valor) => {
    const nums = valor.replace(/\D/g, '');
    if (nums.length <= 11) {
      return nums
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      return nums
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }
  };

  const handleChange = (e) => {
    setCpfCnpj(formatarCpfCnpj(e.target.value));
  };

  const handleBuscar = async () => {
    const valorLimpo = cpfCnpj.replace(/\D/g, '');

    try {
      const response = await api.get("busca/v1/clientecpf", {
        params: {
          codempresa: 1,
          cpf: valorLimpo
        },
      });

      const cli = response.data;

      setDados((prev) => ({
        ...prev,
        etapa1: {
          cliente: {
            nome: cli.nome,
            cpfCnpj: valorLimpo,
            telefone: cli.telefone,
            whatsapp: cli.whatsapp,
            email: cli.email,
            endereco: {
              logradouro: cli.endereco,
              numero: cli.numero,
              bairro: cli.bairro,
              cidade: cli.cidade,
              uf: cli.uf,
              cep: cli.cep
            }
          }
        }
      }));

      console.log('Dados recebidos na etapa 1:', dados);
      onNext();
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setDados((prev) => ({
        ...prev,
        etapa1: {
          cliente: {
            cpfCnpj: valorLimpo
          }
        }
      }));

      onNext();
    }
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <h4 className="fw-semibold mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>
        Identificação do Cliente
      </h4>
      <div className="w-100" style={{ maxWidth: '400px' }}>
        <label className="form-label">CPF ou CNPJ</label>
        <input
          type="text"
          className="form-control text-center"
          placeholder="Digite o CPF ou CNPJ"
          value={cpfCnpj}
          onChange={handleChange}
          maxLength={18}
        />
        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-primary px-4"
            onClick={handleBuscar}
            disabled={cpfCnpj.replace(/\D/g, '').length < 11}
          >
            Consultar
          </button>
        </div>
      </div>
    </div>
  );
}

export default EtapaIdentificacao;
